import { FC } from "react";
import { observer } from "mobx-react-lite";
import {
  SettingsIntegrationPageWrapper,
  SettingsIntegrationHeader,
  SettingsIntegrationScrollableArea,
  SettingsIntegrationSection,
} from "@/pages/settings/components/settings-integration-layout";
import { ChatInstructionsSettings } from "./chat-instructions-settings";

export const SettingsChatPage: FC = observer(() => {
  return (
    <SettingsIntegrationPageWrapper>
      <SettingsIntegrationHeader breadcrumb="General" title="Chat" />
      <SettingsIntegrationScrollableArea>
        <SettingsIntegrationSection>
          <ChatInstructionsSettings />
        </SettingsIntegrationSection>
      </SettingsIntegrationScrollableArea>
    </SettingsIntegrationPageWrapper>
  );
});
